import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker } from 'antd';

export function DateControl({ settings, name, value, onBlur, onChange, ...props }) {
  const format = settings?.format || 'YYYY-MM-DD';
  console.log('value', value)
  return (
    <DatePicker
      width={1}
      name={name}
      allowClear={false}
      value={!!value ? (moment(value, format).isValid() ? moment(value, format) : undefined) : null}
      onBlur={() => onBlur({ target: { name } })}
      onChange={value =>
        onChange({
          target: { name, value: moment(value).format(format) },
        })
      }
      {...settings}
      {...props}
    />
  );
}

DateControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  settings: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
